var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.425 10.2305C24.5565 10.2305 23.8499 10.937 23.8499 11.8055V16.2699H20.3503V13.3526C20.3503 12.9584 20.0294 12.6376 19.6352 12.6376H18.5273V14.1617C18.5273 14.4528 18.2913 14.689 18 14.689C17.7087 14.689 17.4727 14.4528 17.4727 14.1617V12.6376H16.3621C15.9678 12.6376 15.647 12.9584 15.647 13.3526V16.2699H12.1501V11.8055C12.1501 10.937 11.4435 10.2305 10.575 10.2305C9.70656 10.2305 9 10.937 9 11.8055V25.184C9 25.5068 9.26271 25.7695 9.58557 25.7695H11.5643C11.8873 25.7695 12.1501 25.5068 12.1501 25.184V23.6173H23.8499V25.184C23.8499 25.5068 24.1127 25.7695 24.4357 25.7695H26.4144C26.7373 25.7695 27 25.5068 27 25.184V11.8055C27 10.937 26.2934 10.2305 25.425 10.2305V10.2305ZM23.1089 22.5626V19.6674C23.1089 19.2733 22.788 18.9524 22.3938 18.9524H21.2846V20.4765C21.2846 20.7679 21.0484 21.0038 20.7573 21.0038C20.4659 21.0038 20.2299 20.7679 20.2299 20.4765V18.9524H19.1207C18.7263 18.9524 18.4057 19.2733 18.4057 19.6674V22.5626H17.5943V19.6674C17.5943 19.2733 17.2737 18.9524 16.8793 18.9524H15.7701V20.4765C15.7701 20.7679 15.5341 21.0038 15.2427 21.0038C14.9516 21.0038 14.7154 20.7679 14.7154 20.4765V18.9524H13.6062C13.212 18.9524 12.8911 19.2733 12.8911 19.6674V22.5626H12.1501V17.3246H23.8499V22.5626H23.1089Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreStock);
export default __webpack_public_path__ + "static/media/store-stock.cf00e814.svg";
export { ForwardRef as ReactComponent };